/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ScheduleBookingItemDto = {
    /**
     * Session UUID
     */
    sessionId: string;
    /**
     * Client name
     */
    clientName?: Record<string, any>;
    /**
     * Client profile image URL
     */
    clientProfileImage?: Record<string, any>;
    /**
     * Scheduled start time
     */
    startTime: string;
    /**
     * Scheduled end time
     */
    endTime: string;
    /**
     * Session mode
     */
    mode: ScheduleBookingItemDto.mode;
    /**
     * Session status
     */
    status?: ScheduleBookingItemDto.status;
    /**
     * Service type name
     */
    serviceTypeName?: Record<string, any>;
    /**
     * Booking type
     */
    bookingType?: ScheduleBookingItemDto.bookingType;
    /**
     * Reschedule request status
     */
    rescheduleStatus?: Record<string, any> | null;
    /**
     * Booking status
     */
    bookingStatus?: ScheduleBookingItemDto.bookingStatus | null;
};
export namespace ScheduleBookingItemDto {
    /**
     * Session mode
     */
    export enum mode {
        ONLINE = 'online',
        CLIENT_LOCATION = 'client_location',
        EXPERT_LOCATION = 'expert_location',
    }
    /**
     * Session status
     */
    export enum status {
        SCHEDULED = 'scheduled',
        IN_PROGRESS = 'in_progress',
        COMPLETED = 'completed',
        RESCHEDULED = 'rescheduled',
    }
    /**
     * Booking type
     */
    export enum bookingType {
        SINGLE_SESSION = 'single_session',
        PACKAGE = 'package',
    }
    /**
     * Booking status
     */
    export enum bookingStatus {
        PENDING = 'pending',
        ACTIVE = 'active',
        COMPLETED = 'completed',
        CANCELLED = 'cancelled',
        PAYMENT_FAILED = 'payment_failed',
        PAYMENT_FAILED_RETRYABLE = 'payment_failed_retryable',
    }
}

